import { EMPTY_ARRAY } from 'commons-ui';

export const makeActionList = () => {
	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: EMPTY_ARRAY
	};
};

export default {
	makeActionList
};
